import Vue from 'vue'

export default {
  setType(state, { id, type }) {
    let index = state.types.findIndex(el => {
      return el.id == id
    })
    if (index !== -1) {
      Vue.set(state.types, index, type)
    } else {
      state.types.push(type)
    }
  },
  setTypes(state, list = []) {
    let types = [...state.types]
    list.forEach(el => {
      let index = types.findIndex(type => {
        return type.id == el.id
      })
      if (index !== -1) {
        types[index] = el
      } else {
        types.push(el)
      }
    })
    state.types = types
  },
  setTypeGroups(state, { id, groups }) {
    Vue.set(state.typeGroups, id, groups)
  },
  setTypeParams(state, { id, params }) {
    Vue.set(state.typeParams, id, params)
  },
  // Set list of contact types with groups and bindings
  SET_CONTACT_TYPES(state, types) {
    state.contactTypes = types
  },
  // Set list of attributes with values
  SET_ATTRIBUTES(state, attributes) {
    state.attributes = attributes
  },
  // Reset store
  RESET(state) {
    state.types = []
    state.typeGroups = {}
    state.typeParams = {}
    state.contactTypes = false
    state.attributes = false
  }
}



// WEBPACK FOOTER //
// ./src/apps/crm/contacts/store/common/mutations.js